module.exports.Captcha = require('./dist/reactjs-captcha');
module.exports.captchaSettings = require('./dist/captcha-settings');